(() => {
  const accountSelector = 'shopify-account.ps-header-action--account';
  const styleId = 'printspar-shop-login-fix';
  const retryDelay = 50;
  const maxAttempts = 100;

  const translateAccountMenu = (account) => {
    const accountRoot = account.shadowRoot;
    if (!accountRoot) return false;

    const quickLinksLabel = account.dataset.quickLinksLabel || 'Schnellzugriff';
    const ordersLabel = account.dataset.ordersLabel || 'Bestellungen';
    const profileLabel = account.dataset.profileLabel || 'Profil';
    const quickLinks = accountRoot.querySelector('nav[aria-label="Quick links"]');
    quickLinks?.setAttribute('aria-label', quickLinksLabel);

    let translatedLinks = 0;
    [
      ['a[href*="/account/orders"]', ordersLabel],
      ['a[href*="/account/profile"]', profileLabel],
    ].forEach(([selector, label]) => {
      const link = accountRoot.querySelector(selector);
      const textNode = [...(link?.childNodes || [])].find((node) => node.nodeType === Node.TEXT_NODE);
      if (textNode) {
        textNode.textContent = ` ${label}`;
        translatedLinks += 1;
      }
    });

    return Boolean(quickLinks && translatedLinks === 2);
  };

  const revealShopButton = (account, attempt = 0) => {
    const accountMenuTranslated = translateAccountMenu(account);
    const shopLoginRoot = account.shadowRoot?.querySelector('shop-login')?.shadowRoot;

    if (shopLoginRoot) {
      if (!shopLoginRoot.getElementById(styleId)) {
        const style = document.createElement('style');
        style.id = styleId;
        style.textContent = `
          [data-testid='login-button-container'].invisible {
            display: block !important;
            visibility: visible !important;
            opacity: 1 !important;
          }

          [data-testid='login-recognition'],
          [data-testid='card-content'] {
            display: none !important;
          }
        `;
        shopLoginRoot.appendChild(style);
      }

      if (accountMenuTranslated) return;
    }

    if (attempt < maxAttempts) {
      window.setTimeout(() => revealShopButton(account, attempt + 1), retryDelay);
    }
  };

  const prepareAccounts = () => {
    document.querySelectorAll(accountSelector).forEach((account) => revealShopButton(account));
  };

  document.addEventListener(
    'click',
    (event) => {
      const account = event.composedPath().find((node) => node?.matches?.(accountSelector));
      if (account) revealShopButton(account);
    },
    true,
  );

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', prepareAccounts, { once: true });
  } else {
    prepareAccounts();
  }
})();
